import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as SuccessImportacoesActions } from "../../store/ducks/successImportacoes";
import DefaultSnackbar from "../DefaultSnackbar";
import Snackbar from "@material-ui/core/Snackbar";
import { withRouter } from "react-router";

const tenant = localStorage.getItem("@ecorban-app:tenant");

class SuccessImportacoes extends Component {
  render() {
    return (
      <Snackbar
        className="mt2 cursor-pointer"
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        open={this.props.successImportacoes.open}
        onClick={() => this.props.history.push(`/${tenant}/importacoes`)}
        onClose={() => this.props.closeSuccessImportacoes()}
      >
        <DefaultSnackbar
          message={
            <span className="messages p1">
              <i className="fa fa-check-circle green mr2" />
              <span>{this.props.successImportacoes.message}</span>
            </span>
          }
        />
      </Snackbar>
    );
  }
}

const mapStateToProps = state => ({
  successImportacoes: state.successImportacoes
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(SuccessImportacoesActions, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SuccessImportacoes)
);



// WEBPACK FOOTER //
// ./src/components/SuccessImportacoes/index.js